// extracted by mini-css-extract-plugin
module.exports = {"comment":"Comment-module--comment--15ET0"};